import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';

const OndemandLoggedOutApp = loadOnRoute(() => import('bundles/ondemand/components/OndemandLoggedOutApp'));
const OndemandLoggedOutRedirector = loadOnRoute(
  () => import('bundles/ondemand/components/OndemandLoggedOutRedirector')
);

export default (
  <Route path="/learn/:courseSlug" name="loggedOut" getComponent={OndemandLoggedOutApp}>
    {/* note that logged out videos are handled by a separate app */}
    {/*
      The legacy in-course "home/welcome" and "home/info" entry points used to be redirected back to
      the CDP here via a client-side JS redirect. Logged-out requests now receive a server-side 301 at
      the edge (learnHomeWelcomeInfoUnauthRedirect), so those routes have been removed from the app.
    */}
    <Route path="*" getComponent={OndemandLoggedOutRedirector} />
  </Route>
);
